module.exports = __webpack_public_path__ + "1efd43f54a95896e4663ff26049d64f0.svg";